<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>错词管理 - 文件上传</span>
      </div>

      <el-form label-width="100px">
        <el-form-item label="上传文件">
          <single-file-upload
            v-model="fileUrl"
            :max-size="0"
            accept=""
            tips="支持所有文件格式，不限制文件大小"
            @success="handleUploadSuccess"
            @clear="handleUploadClear"
          />
        </el-form-item>
      </el-form>

      <el-row v-if="fileUrl" style="margin-top: 20px;">
        <el-col :span="24">
          <h3>上传结果</h3>
          <el-table :data="[uploadResult]" border style="width: 100%;">
            <el-table-column prop="fileName" label="文件名" min-width="200" show-overflow-tooltip />
            <el-table-column prop="fileUrl" label="文件地址" min-width="300" show-overflow-tooltip />
            <el-table-column prop="fileSize" label="文件大小" width="120" />
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  v-if="isImage(scope.row.fileName)"
                  type="text"
                  icon="el-icon-view"
                  @click="handlePreview">
                  预览
                </el-button>
                <el-button
                  type="text"
                  icon="el-icon-document-copy"
                  @click="handleCopyUrl(scope.row.fileUrl)">
                  复制地址
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>

    <el-dialog
      :visible.sync="previewDialogVisible"
      width="800px"
      title="图片预览"
      :close-on-click-modal="true"
      append-to-body>
      <div class="preview-container">
        <img :src="fileUrl" alt="预览图片" class="preview-image" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SingleFileUpload from '@/components/core/upload/SingleFileUpload.vue'

export default {
  name: 'WrongWordManage',
  components: {
    SingleFileUpload
  },
  data() {
    return {
      fileUrl: '',
      uploadResult: {
        fileName: '',
        fileUrl: '',
        fileSize: ''
      },
      previewDialogVisible: false
    }
  },
  methods: {
    handleUploadSuccess({ url, file }) {
      this.uploadResult = {
        fileName: file.name,
        fileUrl: url,
        fileSize: this.formatFileSize(file.size)
      }
    },
    handleUploadClear() {
      this.uploadResult = { fileName: '', fileUrl: '', fileSize: '' }
    },
    handlePreview() {
      this.previewDialogVisible = true
    },
    handleCopyUrl(url) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success('地址已复制到剪贴板')
        }).catch(() => {
          this.fallbackCopy(url)
        })
      } else {
        this.fallbackCopy(url)
      }
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('地址已复制到剪贴板')
      } catch (e) {
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    },
    isImage(fileName) {
      if (!fileName) return false
      const exts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico']
      return exts.includes(fileName.split('.').pop().toLowerCase())
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.box-card {
  margin-bottom: 20px;
}
h3 {
  margin-bottom: 16px;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}
.preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 20px;
}
.preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>
